export default __webpack_public_path__ + "static/media/WCB_1925.bb1a637f.svg";